export default class Language {
  public static readonly SET_LIST = "LANGUAGE_SET_LIST";
  public static readonly SET_STATUS = "LANGUAGE_SET_STATUS";
  public static readonly SET_ERROR = "LANGUAGE_SET_ERROR";
  public static readonly CLEAR = "LANGUAGE_CLEAR";

  public static setList(data: any) {
    return {
      data,
      type: Language.SET_LIST,
    };
  }

  public static setStatus(data: any) {
    return {
      data,
      type: Language.SET_STATUS,
    };
  }

  public static setError(data: any) {
    return {
      data,
      type: Language.SET_ERROR,
    };
  }

  public static clear() {
    return {
      type: Language.CLEAR,
    };
  }
}
